import Dexie from "dexie";

const db = new Dexie("DigitalMoiOfflineDB");

db.version(1).stores({
  pendingEntries:
    "++id, uuid, event_id, operator_id, sync_status, created_at",
});

export default db;
